import { Injectable } from '@angular/core';
import { map,lastValueFrom } from 'rxjs';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { CommonApiService } from '../common.service';
import { MissingSideMembers } from 'src/state/missing-side-members/state-models/missing-side-members';


@Injectable({
    providedIn: 'root'
})
export class MissingSideMembersApiService {
    constructor(
        private apollo: Apollo,
        private commonService: CommonApiService
    ) { }


    private missingSideMembersSearchQuery=`
    view(allocationScaniaUnit:$allocationScaniaUnit, from: $from, to: $to, paging: $paging, order: $order, filter: $filter) {
      list {
        chassisNumber
        productIndividualNumber
        popId
        productionDate
        invoiceDate
        description
      }
      totalCount
      
    }`;

    exportMissingSideMembers(variables?, fileName: string = null): Promise<any> {
      
          const query = gql`
            query missingSideMembersQuery($allocationScaniaUnit: [Int!], $from: DateTime, $to: DateTime) {
              missingSideMembers {
                  search(allocationScaniaUnit:$allocationScaniaUnit, from: $from, to: $to) {
                    Chassis_No: chassisNumber
                    Product_individual_number: productIndividualNumber
                    Pop_id: popId
                    Production_date: productionDate
                    Invoice_date: invoiceDate
                    Scania_unit: scaniaUnit
                    Description: description
      
                }
              }
            }`;
            
            return this.commonService.exportQuery(query, variables, fileName, true, 'missing side members');
        }

        getMissingSideMembersList(variables?, forceRefetch: boolean = false): Promise<any> {
              const result$ =  this.apollo
                  .query<MissingSideMembers[]>({
                      variables,
                      fetchPolicy: forceRefetch ? 'no-cache' : null,
                      query: gql`
                      query missingSideMembersQuery($allocationScaniaUnit: [Int!], $from: DateTime, $to: DateTime, $paging: Paging, $order:String, $filter:String) {
                        missingSideMembers {
                          
                            ${this.missingSideMembersSearchQuery}
                          
                        }
                      }`
                  })
                  .pipe<MissingSideMembers[]>(
                                   map((result: any) => {
                                    
                          return result?.data?.missingSideMembers?.view;
                      })
                    );
                             
                    return lastValueFrom(result$);  
  }
  
  updateMissingSideMembers(variables?, forceRefetch: boolean = false): Promise<any> {
              const result$ =  this.apollo
                  .query<MissingSideMembers[]>({
                      variables,
                      fetchPolicy: forceRefetch ? 'no-cache' : null,
                      query: gql`
                      query missingSideMembersQuery($allocationScaniaUnit: [Int!], $from: DateTime, $to: DateTime, $paging: Paging, $order:String, $filter:String) {
                        missingSideMembers {                          
                           updateSideMemberData(allocationScaniaUnit: $allocationScaniaUnit,from: $from, to: $to, paging: $paging, order: $order, filter: $filter)                        
                        }
                      }`
                  })
                  .pipe<MissingSideMembers[]>(
                                   map((result: any) => {
                                    
                          return result?.data?.missingSideMembers?.updateSideMemberData;
                      })
                    );
                             
                    return lastValueFrom(result$);  
          }
        }
        